import React, { memo, useCallback, useMemo } from 'react';

import { FormAutocompleteOption } from 'app/shared/components/form/Autocomplete';
import { AutocompleteCDS } from 'app/shared/componentsRestyled/coreDesignSystem/form';
import PropTypes from 'prop-types';

import { groupFieldsFunction } from '../LoanActionsGroup.utils';

import {
  filterActiveTagOptions,
  getSelectedTagOption,
  isSameTagOption,
} from './LoanActionTagSelect.utils';

/**
 * An optional, clearable single-tag picker over the same tag options, grouping and deleted-tag
 * filtering as the Add/Remove tag rows. Calls onChange(name, tagId), with null when cleared.
 */
const LoanActionTagSelect = ({
  dataTestId,
  label,
  name,
  tagsOptions,
  onChange,
  tagId = null,
  isDisabled = false,
}) => {
  const selectedTag = useMemo(
    () => getSelectedTagOption({ tagsOptions, tagId }),
    [tagsOptions, tagId],
  );

  const onTagChange = useCallback(
    (__, option) => onChange(name, option?.value ?? null),
    [name, onChange],
  );

  return (
    <AutocompleteCDS
      OptionContent={FormAutocompleteOption}
      dataTestId={dataTestId}
      disabled={isDisabled}
      filterOptions={filterActiveTagOptions}
      groupBy={groupFieldsFunction}
      isOptionEqualToValue={isSameTagOption}
      label={label}
      name={name}
      options={tagsOptions}
      value={selectedTag}
      onChange={onTagChange}
    />
  );
};

LoanActionTagSelect.propTypes = {
  dataTestId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  tagsOptions: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  tagId: PropTypes.string,
};

export default memo(LoanActionTagSelect);
